import { InfoCircleIconThin } from "../Icons";
import classNames from 'classnames';
import { jsx as _jsx } from "preact/compat/jsx-runtime";
export const TooltipIcon = _ref => {
  let {
    inversed,
    ...iconProps
  } = _ref;
  return /*#__PURE__*/_jsx("span", {
    className: "ds-c-tooltip-icon__container",
    children: /*#__PURE__*/_jsx(InfoCircleIconThin, {
      className: classNames('ds-c-tooltip-icon', {
        'ds-c-tooltip-icon--inverse': inversed
      }),
      ...iconProps
    })
  });
};
export default TooltipIcon;